import * as React from 'react';
import Typography from '@mui/material/Typography';

interface ITituloProps {
  children?: React.ReactNode;
}

export default function Titulo(props: ITituloProps) {
  return (
    <Typography component="h2" variant="h6" color="primary" gutterBottom>
      {props.children}
    </Typography>
  );
}